import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from 'reactstrap'

import profileImg from "../../assets/images/users/profile.png"

import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';

const AdminProfile = ({ modal, setModal }) => {

    // const [name, setName] = useState('Administrator');
    // const [email, setEmail] = useState('admin@peacock.com'); 

    const { name, email, photoPhoto } = secureLocalStorage.getItem("authUser")

    const profileImage = photoPhoto ? `${process.env.REACT_APP_IMAGE_PATH}/${photoPhoto}` : profileImg

    return (
        <Modal size="md" isOpen={modal} centered={true}>

            <div className="modal-content">
                <div className="modal-header py-3 px-4 border-bottom bg-light-purple">
                    <h5 className="modal-title mt-0 text-purple mb-0 d-flex align-items-center">
                        <img src={profileImage}
                            alt=""
                            className='me-3 rounded-circle'
                            style={{ width: 45, height: 45, objectFit: 'cover', objectPosition: 'top' }} />
                        Profile</h5>
                    <button
                        type="button"
                        onClick={() => {
                            setModal(false)
                        }}
                        className="btn-modal-close  bg-white border-0"
                    >
                        <div aria-hidden="true" className="btn-modal-span p-0 fs-5 ">  <i className='fa fa-times'></i> </div>
                    </button>
                </div>
                <ModalBody className="px-4 pb-4">
                    <form autoComplete="off">
                        <div className="row">
                            <div className="col-12 mb-3">
                                <label htmlFor="">Name</label>
                                <div className="form-control input-field view-field">{name}</div>
                            </div>

                            <div className="col-12 mb-3">
                                <label htmlFor="">Email Address</label>
                                <div className="form-control input-field view-field">{email}</div>
                            </div>

                            <div className="mt-4 text-center">
                                <button type='button' onClick={(e) => setModal(false)} className="btn btn-secondary bg-dark ">
                                    <i className="fas fa-times me-2"></i>
                                    Close
                                </button>
                            </div>
                        </div>
                    </form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default AdminProfile